import { render, staticRenderFns } from "./AnggaranSidebar.vue?vue&type=template&id=54c34fa1&scoped=true&"
import script from "./AnggaranSidebar.vue?vue&type=script&lang=js&"
export * from "./AnggaranSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AnggaranSidebar.vue?vue&type=style&index=0&id=54c34fa1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c34fa1",
  null
  
)

export default component.exports